// @ts-ignore
import Lottie from "react-lottie";
import { VFC } from "react";

export const LoadingComponent: VFC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    path: "/lottie/dog-walking.json",
  };

  return <Lottie options={defaultOptions} height={400} width={400} />;
};
